function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#F0A53B"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.59625,
  cy: 4.80328,
  r: 1.44,
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.02131,
  cy: 4.22639,
  r: 0.576,
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.3931,
  cy: 4.80328,
  r: 1.44,
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.8182,
  cy: 4.22639,
  r: 0.576,
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.76609 11.04C6.10552 10.3797 6.60303 9.77965 7.2302 9.27423C7.85738 8.76881 8.60195 8.36789 9.4214 8.09436C10.2408 7.82082 11.1191 7.68004 12.0061 7.68004C12.8931 7.68004 13.7713 7.82082 14.5908 8.09436C15.4102 8.36789 16.1548 8.76881 16.782 9.27423C17.4092 9.77965 17.9067 10.3797 18.2461 11.04",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var Svg6FocusOfAttention = function Svg6FocusOfAttention(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg6FocusOfAttention, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/6_Focus_of_attention.46c39dd4.svg";
export { ForwardRef as ReactComponent };